/** 关系数值在二级页面被写操作改变时，请应用外壳后台刷新 HUD。 */
export const RELATIONSHIP_CHANGED_EVENT = "dreamverse:relationship-changed";

export function notifyRelationshipChanged(): void {
  window.dispatchEvent(new Event(RELATIONSHIP_CHANGED_EVENT));
}
